<template>
  <div class="timutype">
    <!-- 单选 -->
    <div v-if="evaldetail.quList.length == 0">
      <el-empty description="空空如也"></el-empty>
    </div>
    <div class="timList" v-else>
      <div class="timItem" v-for="(item, index) in evaldetail.quList" :key="index">
        <p>
          {{ index + 1 }}. {{ item.content }}
          <span style="color: #1d4434">{{
            item.quType == 0
              ? "(单选)"
              : item.quType == 1
              ? "(多选)"
              : item.quType == 2
              ? "(问答)"
              : ""
          }}</span>
        </p>
        <!-- 单选 -->
        <div v-if="item.quType == 0" class="xuanxList">
          <div v-for="(itemb, indexb) in item.answerList" :key="indexb" class="radiolist">
            <p
              class="anniu"
              :class="itemb.isChoose == true ? 'selrido' : ''"
              @click="redio1(item, itemb)"
            >
              <span></span>
            </p>
            <p class="radioItem" @click="redio1(item, itemb)">{{ itemb.content }}</p>
          </div>
        </div>
        <!-- 多选 -->
        <div v-if="item.quType == 1" class="xuanxList">
          <div v-for="(itemb, indexb) in item.answerList" :key="indexb" class="radiolist">
            <p
              class="anniu"
              :class="itemb.isChoose == true ? 'selrido' : ''"
              @click="redio2(item, itemb)"
            >
              <span></span>
            </p>
            <p class="radioItem" @click="redio1(item, itemb)">{{ itemb.content }}</p>
          </div>
        </div>
        <div v-if="item.quType == 2" class="xuanxList">
          <el-input
            type="textarea"
            style="width: 50%"
            :rows="5"
            resize="none"
            placeholder="请输入"
            v-model="textarea"
          >
          </el-input>
        </div>
      </div>
    </div>
    <!-- 多选 -->
    <!-- 问答 -->
  </div>
</template>

<script>
export default {
  name: "timutype",
  data() {
    return {
      xuanx: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      textarea: "",
    };
  },
  props: {
    evaldetail: {
      type: Object,
      default: {
        quList: [],
      },
    },
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    redio1(item, itemb) {
      for (let index = 0; index < item.answerList.length; index++) {
        if (itemb.id !== item.answerList[index].id) {
          item.answerList[index].isChoose = false;
        }
      }
      itemb.isChoose = !itemb.isChoose;
    },
    redio2(item, itemb) {
      itemb.isChoose = !itemb.isChoose;
    },
  },
};
</script>
<style lang="scss" scoped>
.timutype {
  .timList {
    .timItem {
      margin: 15px 0 0 0;
      .xuanxList {
        margin-top: 15px;
        .radiolist {
          display: flex;
          margin: 15px 0 0 0;
          .anniu {
            width: 20px;
            height: 20px;
            border: 1px solid #bfbfbf;
            border-radius: 50%;
            text-align: center;
            position: relative;
            cursor: pointer;
            span {
              display: inline-block;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .selrido {
            border: 1px solid #1d4434 !important;
            span {
              border: 2px solid #1d4434 !important;
            }
          }
          .radioItem {
            font-size: 16px;
            margin-left: 15px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
